import { IBotPartConfigItemResource } from '../configs/bot-part-configs-structs';
import { CompletePartDataSet } from '../entities/bot-parts';
import { BotPartSlot } from '../entities/bot-part-slots';
import { OptionalStatType, StatType, StatTypeTf } from '../entities/stat.type';
import { EPartItemId } from '../enums';
import { GameId } from '../game-settings/game-constants';
import { IItem } from '../inventory/item-dto.interface';
import { MarketCategory } from '../inventory/market-category.constant';
import { SeasonID } from '../inventory/season-id.enum';

import { MarketType } from './market-type.constant';

export interface IMarketPrice {
  item: IItem;
  count: number;
}

export interface ISkillInfo {
  name: string;
  description: string;
  iconUrl: string;
  stats?: {
    [GameId.ActionGame]: Record<StatType | OptionalStatType, number>;
    [GameId.Terraforming]?: Record<StatTypeTf, number>;
  };
}

export interface IPartInfo {
  slot: BotPartSlot;
  zoa: string;
  tintSlots: string[];
  requiredAnyPart: {
    id: EPartItemId;
    name: string;
  }[];
  resources: {
    defaultTexture?: IBotPartConfigItemResource;
    eyes?: IBotPartConfigItemResource;
  };
  partSkin?: string;
  swatchMaskDatasetKey?: string;
}

export interface IMarketItemInfo extends IItem {
  owned: boolean;
  marketPrice: IMarketPrice;
  skillInfo?: ISkillInfo;
  partInfo?: IPartInfo & {
    previewParts?: CompletePartDataSet;
  };
}
export interface IMarketInfo {
  marketType: MarketType;
  items: MarketCategoryItemInfo;
  wallet: IMarketPrice[];

  // Exclusive to timed shops, such as the seasonal market
  startDate?: number;
  endDate?: number;
  seasonID?: SeasonID;
  seasonNumber?: number;
}

export type MarketCategoryItemInfo = Partial<Record<MarketCategory, IMarketItemInfo[]>>;
